import { KoobButton } from '@koob/ui';
import { useApp, useSnack } from 'hooks';
import { useTranslation } from 'react-i18next';

// Behavior wrapper: role-gates a KoobButton and surfaces an error snack
// when the current user's role is not allowed to use it.
export const RoleButton = ({
  disabledRoles,
  disabledRolesMessage,
  onClick,
  ...props
}) => {
  const { currentUserRole } = useApp();
  const isButtonUsable =
    !disabledRoles || disabledRoles.indexOf(currentUserRole) === -1;
  const { notify } = useSnack();
  const { t } = useTranslation();
  const showError = e => {
    e.preventDefault();
    notify(disabledRolesMessage ? disabledRolesMessage : t('errors:noRight'), {
      type: 'error',
    });
  };
  return (
    <KoobButton {...props} onClick={isButtonUsable ? onClick : showError} />
  );
};
